import { Typography } from '@material-ui/core';
import { InfoCard, Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { useFormikContext } from 'formik';
import { useBypassNavigationPrompt } from 'shared/routing/NavigationBlock';
import { ProfilePageLayout } from '../../ProfilePageLayout';
import { SUPERPAY_PROFILE_ROUTES } from '../SuperPayRoute';
import {
  BankAccountForm,
  BankAccountLegalNotice,
  useBankAccountSetupForm,
} from './BankAccountForm';

function BankAccountContent() {
  const { submitForm, isSubmitting, dirty } = useFormikContext();
  return (
    <Stack space="small">
      <BankAccountLegalNotice />
      <InfoCard>
        <Stack>
          <Typography variant="h3">Bank Account</Typography>
          <Stack space="small">
            <BankAccountForm />
            <Button
              onClick={() => {
                void submitForm();
              }}
              pending={isSubmitting}
              disabled={!dirty}
            >
              Submit
            </Button>
          </Stack>
        </Stack>
      </InfoCard>
    </Stack>
  );
}

export function BankAccountPage() {
  const navigate = useBypassNavigationPrompt();

  const { formik, isFetching } = useBankAccountSetupForm({
    onVerificationRequired: () => {
      navigate(
        `${SUPERPAY_PROFILE_ROUTES.bankVerification}?utm_medium=Bank Details`,
      );
    },
  });

  return (
    <ProfilePageLayout
      title="Setup SuperPay"
      actions={false}
      isLoading={formik.isSubmitting || isFetching}
      formik={formik}
    >
      <Box
        paddingTop="small"
        maxWidth={['initial', 'initial', '528px']}
        margin="auto"
      >
        <BankAccountContent />
      </Box>
    </ProfilePageLayout>
  );
}
